export const defaultRegistrationFormQuestionNames = [
  'page1',
  'registrant_firstName',
  'registrant_lastName',
  'registrant_email',
  'countryCode_phoneNumber',
  'registrant_countryCode',
  'registrant_phoneNumber',
  'register_sessions',
];

export const nameElements = [
  {
    type: 'text',
    name: 'registrant_firstName',
    title: {
      default: 'First Name',
      en: 'First Name',
    },
    isRequired: true,
    maxLength: 25,
    requiredErrorText: {
      default: 'Field is required',
      en: 'Field is required',
    },
  },
  {
    type: 'text',
    name: 'registrant_lastName',
    title: {
      default: 'Last Name',
      en: 'Last Name',
    },
    isRequired: true,
    maxLength: 25,
  },
];

export const emailElement = {
  type: 'text',
  name: 'registrant_email',
  title: { default: 'Email', en: 'Email' },
  placeholder: {
    default: 'Please input',
    en: 'Please input',
  },
  requiredErrorText: {
    default: 'Field is required',
    en: 'Field is required',
  },
  validators: [
    {
      type: 'email',
      text: {
        default: 'Please enter a valid email address',
        en: 'Please enter a valid email address',
      },
    },
  ],
  isRequired: true,
  allowAddPanel: false,
  allowRemovePanel: false,
};

export const phoneElement = {
  type: 'panel',
  name: 'countryCode_phoneNumber',
  title: { default: 'Phone Number', en: 'Phone Number' },
  requiredErrorText: {
    default: 'Field is required',
    en: 'Field is required',
  },
  placeholder: {
    default: 'Please input',
    en: 'Please input',
  },
  elements: [
    {
      type: 'dropdown',
      name: 'registrant_countryCode',
      title: {
        default: 'Region',
        en: 'Region',
      },
      requiredErrorText: {
        default: 'Field is required',
        en: 'Field is required',
      },
      isRequired: true,
      width: '40%',
      minWidth: '0',
    },
    {
      type: 'text',
      name: 'registrant_phoneNumber',
      startWithNewLine: true,
      title: {
        default: 'Phone',
        en: 'Phone',
      },
      requiredErrorText: {
        default: 'Field is required',
        en: 'Field is required',
      },
      validators: [
        {
          type: 'expression',
          text: {
            default: 'Invalid phone number',
            en: 'Invalid phone number',
          },
          expression: 'phoneNumberValidate({registrant_countryCode}, {registrant_phoneNumber})',
        },
      ],
      isRequired: true,
      width: '60%',
      minWidth: '0',
    },
  ],
  isRequired: true,
  allowAddPanel: false,
  allowRemovePanel: false,
  showNumber: true,
  showQuestionNumbers: 'off',
};
